// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YGfkN","select":"styles_select__1wko2"};